'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _bluebird = require('bluebird');

/**
 * Check an IS URL is valid, including liveness check
 *
 * @param {string} u The url to check
 * @returns {string} null if url passes all checks, otherwise i18ned error string
 */
var checkIdentityServerUrl = function () {
    var _ref = (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee(u) {
        var parsedUrl, response;
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        parsedUrl = _url2.default.parse(u);

                        if (!(parsedUrl.protocol !== 'https:')) {
                            _context.next = 3;
                            break;
                        }

                        return _context.abrupt('return', (0, _languageHandler._t)("Identity Server URL must be HTTPS"));

                    case 3:
                        _context.prev = 3;
                        _context.next = 6;
                        return (0, _bluebird.resolve)(fetch(u + '/_matrix/identity/api/v1'));

                    case 6:
                        response = _context.sent;

                        if (!response.ok) {
                            _context.next = 11;
                            break;
                        }

                        return _context.abrupt('return', null);

                    case 11:
                        if (!(response.status < 200 || response.status >= 300)) {
                            _context.next = 15;
                            break;
                        }

                        return _context.abrupt('return', (0, _languageHandler._t)("Not a valid Identity Server (status code %(code)s)", { code: response.status }));

                    case 15:
                        return _context.abrupt('return', (0, _languageHandler._t)("Could not connect to Identity Server"));

                    case 16:
                        _context.next = 21;
                        break;

                    case 18:
                        _context.prev = 18;
                        _context.t0 = _context['catch'](3);
                        return _context.abrupt('return', (0, _languageHandler._t)("Could not connect to Identity Server"));

                    case 21:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this, [[3, 18]]);
    }));

    return function checkIdentityServerUrl(_x) {
        return _ref.apply(this, arguments);
    };
}(); /*
     Copyright 2019 The Matrix.org Foundation C.I.C.
     
     Licensed under the Apache License, Version 2.0 (the "License");
     you may not use this file except in compliance with the License.
     You may obtain a copy of the License at
     
         http://www.apache.org/licenses/LICENSE-2.0
     
     Unless required by applicable law or agreed to in writing, software
     distributed under the License is distributed on an "AS IS" BASIS,
     WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     See the License for the specific language governing permissions and
     limitations under the License.
     */

var _url = require('url');

var _url2 = _interopRequireDefault(_url);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _languageHandler = require('../../../languageHandler');

var _index = require('../../../index');

var _index2 = _interopRequireDefault(_index);

var _MatrixClientPeg = require('../../../MatrixClientPeg');

var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);

var _Modal = require('../../../Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _dispatcher = require('../../../dispatcher');

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _boundThreepids = require('../../../boundThreepids');

var _IdentityAuthClient = require('../../../IdentityAuthClient');

var _IdentityAuthClient2 = _interopRequireDefault(_IdentityAuthClient);

var _matrixJsSdk = require('matrix-js-sdk');

var _UrlUtils = require('../../../utils/UrlUtils');

var _IdentityServerUtils = require('../../../utils/IdentityServerUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SetIdServer = function (_React$Component) {
    (0, _inherits3.default)(SetIdServer, _React$Component);

    function SetIdServer() {
        var _this2 = this;

        (0, _classCallCheck3.default)(this, SetIdServer);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SetIdServer.__proto__ || (0, _getPrototypeOf2.default)(SetIdServer)).call(this));

        _this.onAction = function (payload) {
            // We react to changes in the ID server in the event the user is staring at this form
            // when changing their identity server on another device.
            if (payload.action !== "id_server_changed") return;

            _this.setState({
                currentClientIdServer: _MatrixClientPeg2.default.get().getIdentityServerUrl()
            });
        };

        _this._onIdentityServerChanged = function (ev) {
            var u = ev.target.value;

            _this.setState({ idServer: u });
        };

        _this._getTooltip = function () {
            if (_this.state.checking) {
                var InlineSpinner = _index2.default.getComponent('views.elements.InlineSpinner');
                return _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(InlineSpinner, null),
                    (0, _languageHandler._t)("Checking server")
                );
            } else if (_this.state.error) {
                return _react2.default.createElement(
                    'span',
                    { className: 'warning' },
                    _this.state.error
                );
            } else {
                return null;
            }
        };

        _this._idServerChangeEnabled = function () {
            return !!_this.state.idServer && !_this.state.busy;
        };

        _this._saveIdServer = function (fullUrl) {
            // Account data change will update localstorage, client, etc through dispatcher
            _MatrixClientPeg2.default.get().setAccountData("m.identity_server", {
                base_url: fullUrl
            });
            _this.setState({
                busy: false,
                error: null,
                currentClientIdServer: fullUrl,
                idServer: ''
            });
        };

        _this._checkIdServer = function () {
            var _ref2 = (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(e) {
                var _this$state, idServer, currentClientIdServer, fullUrl, errStr, authClient, save, terms, _ref3, _ref4, confirmed, _ref5, _ref6, _confirmed;

                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                e.preventDefault();
                                _this$state = _this.state, idServer = _this$state.idServer, currentClientIdServer = _this$state.currentClientIdServer;


                                _this.setState({ busy: true, checking: true, error: null });

                                fullUrl = (0, _UrlUtils.unabbreviateUrl)(idServer);
                                _context2.next = 6;
                                return (0, _bluebird.resolve)(checkIdentityServerUrl(fullUrl));

                            case 6:
                                errStr = _context2.sent;

                                if (errStr) {
                                    _context2.next = 50;
                                    break;
                                }

                                _context2.prev = 8;

                                _this.setState({ checking: false }); // clear tooltip

                                // Test the identity server by trying to register with it. This
                                // may result in a terms of service prompt.
                                authClient = new _IdentityAuthClient2.default(fullUrl);
                                _context2.next = 13;
                                return (0, _bluebird.resolve)(authClient.getAccessToken());

                            case 13:
                                save = true;

                                // Double check that the identity server even has terms of service.

                                terms = void 0;
                                _context2.prev = 15;
                                _context2.next = 18;
                                return (0, _bluebird.resolve)(_MatrixClientPeg2.default.get().getTerms(_matrixJsSdk.SERVICE_TYPES.IS, fullUrl));

                            case 18:
                                terms = _context2.sent;
                                _context2.next = 29;
                                break;

                            case 21:
                                _context2.prev = 21;
                                _context2.t0 = _context2['catch'](15);

                                console.error(_context2.t0);

                                if (!(_context2.t0.cors === "rejected" || _context2.t0.httpStatus === 404)) {
                                    _context2.next = 28;
                                    break;
                                }

                                terms = null;
                                _context2.next = 29;
                                break;

                            case 28:
                                throw _context2.t0;

                            case 29:
                                if (!(!terms || !terms["policies"] || (0, _keys2.default)(terms["policies"]).length <= 0)) {
                                    _context2.next = 36;
                                    break;
                                }

                                _context2.next = 32;
                                return (0, _bluebird.resolve)(_this._showNoTermsWarning(fullUrl));

                            case 32:
                                _ref3 = _context2.sent;
                                _ref4 = (0, _slicedToArray3.default)(_ref3, 1);
                                confirmed = _ref4[0];

                                save = confirmed;

                            case 36:
                                if (!(save && currentClientIdServer && fullUrl !== currentClientIdServer)) {
                                    _context2.next = 43;
                                    break;
                                }

                                _context2.next = 39;
                                return (0, _bluebird.resolve)(_this._showServerChangeWarning({
                                    title: (0, _languageHandler._t)("Change identity server"),
                                    unboundMessage: (0, _languageHandler._t)("Disconnect from the identity server <current /> and " + "connect to <new /> instead?", {}, {
                                        current: function current(sub) {
                                            return _react2.default.createElement(
                                                'b',
                                                null,
                                                (0, _UrlUtils.abbreviateUrl)(currentClientIdServer)
                                            );
                                        },
                                        new: function _new(sub) {
                                            return _react2.default.createElement(
                                                'b',
                                                null,
                                                (0, _UrlUtils.abbreviateUrl)(idServer)
                                            );
                                        }
                                    }),
                                    button: (0, _languageHandler._t)("Continue")
                                }));

                            case 39:
                                _ref5 = _context2.sent;
                                _ref6 = (0, _slicedToArray3.default)(_ref5, 1);
                                _confirmed = _ref6[0];

                                save = _confirmed;

                            case 43:

                                if (save) {
                                    _this._saveIdServer(fullUrl);
                                }
                                _context2.next = 50;
                                break;

                            case 46:
                                _context2.prev = 46;
                                _context2.t1 = _context2['catch'](8);

                                console.error(_context2.t1);
                                errStr = (0, _languageHandler._t)("Terms of service not accepted or the identity server is invalid.");

                            case 50:
                                _this.setState({
                                    busy: false,
                                    checking: false,
                                    error: errStr,
                                    currentClientIdServer: _MatrixClientPeg2.default.get().getIdentityServerUrl()
                                });

                            case 51:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2, [[8, 46], [15, 21]]);
            }));

            return function (_x2) {
                return _ref2.apply(this, arguments);
            };
        }();

        _this._onDisconnectClicked = (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
            var _ref8, _ref9, confirmed;

            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _this.setState({ disconnectBusy: true });
                            _context3.prev = 1;
                            _context3.next = 4;
                            return (0, _bluebird.resolve)(_this._showServerChangeWarning({
                                title: (0, _languageHandler._t)("Disconnect identity server"),
                                unboundMessage: (0, _languageHandler._t)("Disconnect from the identity server <idserver />?", {}, { idserver: function idserver(sub) {
                                        return _react2.default.createElement(
                                            'b',
                                            null,
                                            (0, _UrlUtils.abbreviateUrl)(_this.state.currentClientIdServer)
                                        );
                                    } }),
                                button: (0, _languageHandler._t)("Disconnect")
                            }));

                        case 4:
                            _ref8 = _context3.sent;
                            _ref9 = (0, _slicedToArray3.default)(_ref8, 1);
                            confirmed = _ref9[0];

                            if (confirmed) {
                                _this._disconnectIdServer();
                            }

                        case 8:
                            _context3.prev = 8;

                            _this.setState({ disconnectBusy: false });
                            return _context3.finish(8);

                        case 11:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this2, [[1,, 8, 11]]);
        }));

        _this._disconnectIdServer = function () {
            // Account data change will update localstorage, client, etc through dispatcher
            _MatrixClientPeg2.default.get().setAccountData("m.identity_server", {
                base_url: null // clear
            });

            var newFieldVal = '';
            if ((0, _IdentityServerUtils.getDefaultIdentityServerUrl)()) {
                // Prepopulate the client's default so the user at least has some idea of
                // a valid value they might enter
                newFieldVal = (0, _UrlUtils.abbreviateUrl)((0, _IdentityServerUtils.getDefaultIdentityServerUrl)());
            }

            _this.setState({
                busy: false,
                error: null,
                currentClientIdServer: _MatrixClientPeg2.default.get().getIdentityServerUrl(),
                idServer: newFieldVal
            });
        };

        var defaultIdServer = '';
        if (!_MatrixClientPeg2.default.get().getIdentityServerUrl() && (0, _IdentityServerUtils.getDefaultIdentityServerUrl)()) {
            // If no ID server is configured but there's one in the config, prepopulate
            // the field to help the user.
            defaultIdServer = (0, _UrlUtils.abbreviateUrl)((0, _IdentityServerUtils.getDefaultIdentityServerUrl)());
        }

        _this.state = {
            defaultIdServer: defaultIdServer,
            currentClientIdServer: _MatrixClientPeg2.default.get().getIdentityServerUrl(),
            idServer: "",
            error: null,
            busy: false,
            disconnectBusy: false,
            checking: false
        };
        return _this;
    }

    (0, _createClass3.default)(SetIdServer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.dispatcherRef = _dispatcher2.default.register(this.onAction);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _dispatcher2.default.unregister(this.dispatcherRef);
        }
    }, {
        key: '_showNoTermsWarning',
        value: function _showNoTermsWarning(fullUrl) {
            var QuestionDialog = _index2.default.getComponent("views.dialogs.QuestionDialog");

            var _Modal$createTrackedD = _Modal2.default.createTrackedDialog('No Terms Warning', '', QuestionDialog, {
                title: (0, _languageHandler._t)("Identity server has no terms of service"),
                description: _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'span',
                        { className: 'warning' },
                        (0, _languageHandler._t)("The identity server you have chosen does not have any terms of service.")
                    ),
                    _react2.default.createElement(
                        'span',
                        null,
                        '\xA0',
                        (0, _languageHandler._t)("Only continue if you trust the owner of the server.")
                    )
                ),
                button: (0, _languageHandler._t)("Continue")
            }),
                finished = _Modal$createTrackedD.finished;

            return finished;
        }
    }, {
        key: '_showServerChangeWarning',
        value: function () {
            var _ref10 = (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(_ref11) {
                var _this3 = this;

                var title = _ref11.title,
                    unboundMessage = _ref11.unboundMessage,
                    button = _ref11.button;

                var threepids, boundThreepids, message, danger, QuestionDialog, _Modal$createTrackedD2, finished;

                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return (0, _bluebird.resolve)((0, _boundThreepids.getThreepidsWithBindStatus)(_MatrixClientPeg2.default.get()));

                            case 2:
                                threepids = _context4.sent;
                                boundThreepids = threepids.filter(function (tp) {
                                    return tp.bound;
                                });
                                message = void 0;
                                danger = false;

                                if (boundThreepids.length) {
                                    message = _react2.default.createElement(
                                        'div',
                                        null,
                                        _react2.default.createElement(
                                            'p',
                                            null,
                                            (0, _languageHandler._t)("You are still <b>sharing your personal data</b> on the identity " + "server <idserver />.", {}, {
                                                idserver: function idserver(sub) {
                                                    return _react2.default.createElement(
                                                        'b',
                                                        null,
                                                        (0, _UrlUtils.abbreviateUrl)(_this3.state.currentClientIdServer)
                                                    );
                                                },
                                                b: function b(sub) {
                                                    return _react2.default.createElement(
                                                        'b',
                                                        null,
                                                        sub
                                                    );
                                                }
                                            })
                                        ),
                                        _react2.default.createElement(
                                            'p',
                                            null,
                                            (0, _languageHandler._t)("We recommend that you remove your email addresses and phone numbers " + "from the identity server before disconnecting.")
                                        )
                                    );
                                    danger = true;
                                    button = (0, _languageHandler._t)("Disconnect anyway");
                                } else {
                                    message = unboundMessage;
                                }

                                QuestionDialog = _index2.default.getComponent("dialogs.QuestionDialog");
                                _Modal$createTrackedD2 = _Modal2.default.createTrackedDialog('Identity Server Bound Warning', '', QuestionDialog, {
                                    title: title,
                                    description: message,
                                    button: button,
                                    cancelButton: (0, _languageHandler._t)("Go back"),
                                    danger: danger
                                }), finished = _Modal$createTrackedD2.finished;
                                return _context4.abrupt('return', finished);

                            case 10:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function _showServerChangeWarning(_x3) {
                return _ref10.apply(this, arguments);
            }

            return _showServerChangeWarning;
        }()
    }, {
        key: 'render',
        value: function render() {
            var AccessibleButton = _index2.default.getComponent('views.elements.AccessibleButton');
            var Field = _index2.default.getComponent('elements.Field');
            var idServerUrl = this.state.currentClientIdServer;
            var sectionTitle = void 0;
            var bodyText = void 0;
            if (idServerUrl) {
                sectionTitle = (0, _languageHandler._t)("Identity Server (%(server)s)", { server: (0, _UrlUtils.abbreviateUrl)(idServerUrl) });
                bodyText = (0, _languageHandler._t)("You are currently using <server></server> to discover and be discoverable by " + "existing contacts you know. You can change your identity server below.", {}, { server: function server(sub) {
                        return _react2.default.createElement(
                            'b',
                            null,
                            (0, _UrlUtils.abbreviateUrl)(idServerUrl)
                        );
                    } });
                if (this.props.missingTerms) {
                    bodyText = (0, _languageHandler._t)("If you don't want to use <server /> to discover and be discoverable by existing " + "contacts you know, enter another identity server below.", {}, { server: function server(sub) {
                            return _react2.default.createElement(
                                'b',
                                null,
                                (0, _UrlUtils.abbreviateUrl)(idServerUrl)
                            );
                        } });
                }
            } else {
                sectionTitle = (0, _languageHandler._t)("Identity Server");
                bodyText = (0, _languageHandler._t)("You are not currently using an identity server. " + "To discover and be discoverable by existing contacts you know, " + "add one below.");
            }

            var discoSection = void 0;
            if (idServerUrl) {
                var discoButtonContent = (0, _languageHandler._t)("Disconnect");
                var discoBodyText = (0, _languageHandler._t)("Disconnecting from your identity server will mean you " + "won't be discoverable by other users and you won't be " + "able to invite others by email or phone.");
                if (this.props.missingTerms) {
                    discoBodyText = (0, _languageHandler._t)("Using an identity server is optional. If you choose not to " + "use an identity server, you won't be discoverable by other users " + "and you won't be able to invite others by email or phone.");
                    discoButtonContent = (0, _languageHandler._t)("Do not use an identity server");
                }
                if (this.state.disconnectBusy) {
                    var InlineSpinner = _index2.default.getComponent('views.elements.InlineSpinner');
                    discoButtonContent = _react2.default.createElement(InlineSpinner, null);
                }
                discoSection = _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'span',
                        { className: 'mx_SettingsTab_subsectionText' },
                        discoBodyText
                    ),
                    _react2.default.createElement(
                        AccessibleButton,
                        { onClick: this._onDisconnectClicked, kind: 'danger_sm' },
                        discoButtonContent
                    )
                );
            }

            return _react2.default.createElement(
                'form',
                { className: 'mx_SettingsTab_section mx_SetIdServer', onSubmit: this._checkIdServer },
                _react2.default.createElement(
                    'span',
                    { className: 'mx_SettingsTab_subheading' },
                    sectionTitle
                ),
                _react2.default.createElement(
                    'span',
                    { className: 'mx_SettingsTab_subsectionText' },
                    bodyText
                ),
                _react2.default.createElement(Field, { label: (0, _languageHandler._t)("Enter a new identity server"),
                    id: 'mx_SetIdServer_idServer',
                    type: 'text',
                    autoComplete: 'off',
                    placeholder: this.state.defaultIdServer,
                    value: this.state.idServer,
                    onChange: this._onIdentityServerChanged,
                    tooltipContent: this._getTooltip(),
                    tooltipClassName: 'mx_SetIdServer_tooltip',
                    disabled: this.state.busy,
                    flagInvalid: !!this.state.error
                }),
                _react2.default.createElement(
                    AccessibleButton,
                    { type: 'submit', kind: 'primary_sm',
                        onClick: this._checkIdServer,
                        disabled: !this._idServerChangeEnabled()
                    },
                    (0, _languageHandler._t)("Change")
                ),
                discoSection
            );
        }
    }]);
    return SetIdServer;
}(_react2.default.Component);

SetIdServer.propTypes = {
    // Whether or not the ID server is missing terms. This affects the text
    // shown to the user.
    missingTerms: _propTypes2.default.bool
};
exports.default = SetIdServer;
module.exports = exports['default'];
//# sourceMappingURL=SetIdServer.js.map